var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"answer-image-container",style:({
    ..._vm.boxStyle
  })},[_c('div',{class:['image-container', { overflow: parseInt(_vm.$attrs.width) > 100 }]},[_c('van-image',_vm._b({attrs:{"fit":"contain"}},'van-image',{ ..._vm.$attrs, ..._vm.vanImageAttrs },false))],1),(parseInt(_vm.$attrs.width) > 100)?_c('div',{staticClass:"tips"},[_vm._v("《 左右滑动查看完整流程 》")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }